module.exports = __webpack_public_path__ + "img/employee_3.d91cb834.jpg";